import { GRID_SIZE } from "../constants";

export const NOTE_RADIUS = 12;
export const NOTE_STARTING_POINT_RADIUS = 7;
export const FONT_SIZE = 12;
export const STROKE_WIDTH = 2;
export const STROKE_SHADOW_WIDTH = 2;
export const HIGHLIGHT_OFFSET = GRID_SIZE / 4;
